// Import style lib
import styled from 'styled-components';

// Import colors
import colors from '../../utils/styles/colors';

// Image editor container
export const ImageEditorContainer = styled.div`
    /* Appearance */
    background-color: white;
    border-radius: 10px;

    /* Element disposition */
    position: absolute;
    z-index: 1000;

    /* Content disposition */
    display: flex;
    flex-direction: column;
    align-items: center;

    /* Size */
    width: 80%;
    max-width: 1200px;

    /* Spacing */
    padding: 50px;
    gap: 30px;

    /* Visual effects */
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.5);

    /* Mobile setup */
    @media (max-width: 600px) {
        width: 90vw;
        gap: 10px;

        padding: 15px;
    }
`;

// Title
export const ImageEditorTitle = styled.h1``;

// Layout for diplaying all images
export const ImageLayout = styled.div`
    /* Content disposition */
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 20px;

    /* Mobile setup */
    @media (max-width: 600px) {
        gap: 15px;
    }
`;

// Image container
export const ImageContainer = styled.div`
    /* Element disposition */
    position: relative;

    /* Size */
    width: 250px;
    height: 250px;

    /* Visual effects */
    box-shadow: 0px 4px 6px hsla(0, 0%, 0%, 0.3);

    /* Mobile setup */
    @media (max-width: 600px) {
        width: 130px;
        height: 130px;
    }
`;

// Images
export const Image = styled.img`
    /* Element disposition */
    object-fit: contain;
    object-position: center;

    /* Size */
    width: 100%;
    height: 100%;
`;

// Delete button
export const DeleteButton = styled.button`
    /* Element disposition */
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 1;

    /* Events */
    cursor: pointer;

    /* Mobile setup */
    @media (max-width: 600px) {
        top: 1vw;
        right: 1vw;
    }
`;

// Import Label
export const ImportLabel = styled.label`
    /* Appearance */
    background-color: ${colors.primaryBeige};
    border-radius: 10px;

    /* Content disposition */
    display: flex;
    align-items: center;
    justify-content: center;

    /* Spacing */
    padding: 5px 10px;

    /* Visual effects */
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.3);

    /* Events */
    cursor: pointer;
    &:hover {
        filter: brightness(1.2);
    }
`;

// Close Button
export const CloseButton = styled.button`
    /* Element disposition */
    position: absolute;
    top: 20px;
    left: 20px;
    z-index: 1;

    /* Events */
    cursor: pointer;

    /* Mobile setup */
    @media (max-width: 600px) {
        top: 15px;
        left: 15px;
    }
`;

// Icon
export const Icon = styled.svg`
    /* Appearance */
    fill: ${colors.primaryBeige};

    /* Size */
    width: ${(props) => props.width}px;
    height: ${(props) => props.width}px;

    &:hover {
        filter: brightness(1.2);
    }
`;

// Styled shade overlay
export const Overlay = styled.div`
    /* Appearance */
    background: rgba(0, 0, 0, 0.5);

    /* Element disposition */
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;

    /* Size */
    width: 100%;
    height: 100%;
`;
